import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { API_ENDPOINT$ } from 'src/app/shared/index';
import { SolarConfigModel } from '../../../models/solar-configuration.model';
import { DataService } from '../../../services/data.service';
@Injectable()
export class PlantServiceService {
  solarConfigSubject: Subject<SolarConfigModel>;
  private siteIdSubject = new Subject<string>();
  private subject = new Subject<any>();
  private siteDetailSubject = new Subject<any>();
  private siteDetailUrl = `${API_ENDPOINT$}/common/getSiteDetailsBySiteId`;
  private altSourcesDetailsUrl = `${API_ENDPOINT$}/common/getAltSourcesDetails`;
  private latestIrradianceUrl = `${API_ENDPOINT$}/solar/getLatestIrradianceDataOfSite`;
  private sensorHealthBasedOnLevelUrl = `${API_ENDPOINT$}/site/getSensorHealthBasedOnLevel`;
  private solarConfigurationInfoUrl = `${API_ENDPOINT$}/solar/getSolarConfigurationInfo`;
  private plantKeyOperationDataUrl = `${API_ENDPOINT$}/solar/getPlantKeyOperationData`;
  private latestModuleTemp = `${API_ENDPOINT$}/solar/getLatestModuleTemp`;
  // eslint-disable-next-line max-len
  private performanceRatioOnedayOfSiteUrl = `${API_ENDPOINT$}/solar/getLatestPerformanceRatioOnedayOfSite`;
  private solarEnergyUrl = `${API_ENDPOINT$}/solar/getTotalSolarEnergyYieldTrend`;
  private solarDataTrendUrl = `${API_ENDPOINT$}/solar/getSolarDataTrend`;
  private solarEnergyYieldUrl = `${API_ENDPOINT$}/solar/getSolarEnergyYieldBySiteId`;
  private solarLongTermTrendsBuildingWiseUrl = `${API_ENDPOINT$}/solar/getSolarLongTermTrendsBuildingWise`;
  private solarEnergyYieldTrendBuildingWiseUrl = `${API_ENDPOINT$}/solar/getSolarEnergyYieldTrendBuildingWise`;
  private powerAndIrradianceTrendUrl = `${API_ENDPOINT$}/solar/getPowerAndIrradianceTrend`;
  private shiftsBySiteIdUrl = `${API_ENDPOINT$}/common/getShiftsBySiteId`;
  private solarEnergyTrendsDataUrl = `${API_ENDPOINT$}/solar/getSolarEnergyTrends`;
  private getWindSpeedUrl = `${API_ENDPOINT$}/solar/getWindSpeed`;
  constructor(private dataService: DataService) {
    this.solarConfigSubject = new Subject<SolarConfigModel>();
    this.siteDetailSubject = new Subject<any>();
  }
  public sendLastedTotalACPower(value: any) {
    this.subject.next({ text: value });
  }
  public clearLastedTotalACPower() {
    this.subject.next(null);
  }
  public getLastedTotalACPower(): Observable<any> {
    return this.subject.asObservable();
  }
  public sendSolarConfigSubject(model: SolarConfigModel) {
    this.solarConfigSubject.next(model);
  }
  public clearSolarConfigSubject() {
    // this.solarConfigSubject.next();
    this.solarConfigSubject.complete();
  }
  public unSubscribeSolarConfigSubject() {
    this.solarConfigSubject.observers = [];
  }
  public getSolarConfigSubject() {
    return this.solarConfigSubject;
  }
  public sendSiteDetailSubject(data: any) {
    this.siteDetailSubject.next(data);
  }
  public getSiteDetailSubject(): Observable<any> {
    return this.siteDetailSubject.asObservable();
  }
  public unSubscribeSiteDetailSubject = () => {
    this.siteDetailSubject.observers = [];
  };
  public getSiteDetail(siteId: string): Observable<any> {
    return this.dataService.getData(this.siteDetailUrl + '/' + siteId);
  }
  public getAltSourcesDetails(siteId: string): Observable<any> {
    return this.dataService.getData(this.altSourcesDetailsUrl + '/' + siteId);
  }

  public getSolarConfigurationInfo(siteId: string): Observable<any> {
    return this.dataService.getData(
      this.solarConfigurationInfoUrl + '/' + siteId
    );
  }
  public getLatestModuleTemp(siteId: string): Observable<any> {
    return this.dataService.getData(this.latestModuleTemp + '/' + siteId);
  }
  public getLatestIrradianceDataOfSite(
    siteId: string,
    hideLoading: boolean
  ): Observable<any> {
    return this.dataService.getData(
      this.latestIrradianceUrl + '/' + siteId,
      hideLoading
    );
  }
  public getPlantKeyOperationData(siteId: string): Observable<any> {
    return this.dataService.getData(
      this.plantKeyOperationDataUrl + '/' + siteId
    );
  }
  public getSensorHealthBasedOnLevel(
    siteId: string,
    level: string
  ): Observable<any> {
    const model = { SiteID: siteId, Level: level, Role: 'Solar' };
    return this.dataService.postData(this.sensorHealthBasedOnLevelUrl, model);
  }
  // Performance chacteristic charts
  public getLatestPerformanceRatioOnedayOfSite(
    siteId: string,
    totalInstalledCapacity: string
  ): Observable<any> {
    return this.dataService.getData(
      this.performanceRatioOnedayOfSiteUrl +
        '/' +
        siteId +
        `/` +
        totalInstalledCapacity,
      false
    );
  }
  public getTotalSolarEnergyYieldTrend(siteId: string): Observable<any> {
    return this.dataService.getData(this.solarEnergyUrl + '/' + siteId);
  }

  public getSolarDataTrend(model: any): Observable<any> {
    return this.dataService.saveData(this.solarDataTrendUrl, model);
  }
  public getSolarEnergyYieldBySiteId(
    siteId: string,
    startDate: string,
    endDate: string,
    hourWiseDataRequired: boolean
  ): Observable<any> {
    // eslint-disable-next-line max-len
    return this.dataService.getData(
      this.solarEnergyYieldUrl +
        '/' +
        siteId +
        `/` +
        startDate +
        `/` +
        endDate +
        `/` +
        hourWiseDataRequired,
      false
    );
  }
  // eslint-disable-next-line max-len
  public getSolarEnergyYieldTrendBuildingWise(
    siteId: string,
    startDate: string,
    endDate: string,
    hourWiseDataRequired: boolean,
    meterRole: string
  ): Observable<any> {
    const model = {
      siteId: siteId,
      startDate: startDate,
      endDate: endDate,
      hourWiseDataRequired: hourWiseDataRequired,
      meterRole: meterRole
    };
    // const model = {siteId: 'JAPBOSCH30201064', startDate: '2019-06-10',
    //    endDate: '2019-06-10', hourWiseDataRequired: true,
    //    meterRole: 'Solar'};

    // eslint-disable-next-line max-len
    return this.dataService.postData(
      this.solarEnergyYieldTrendBuildingWiseUrl,
      model,
      false
    );
  }
  public getPowerAndIrradianceTrend(model: any): Observable<any> {
    return this.dataService.saveData(this.powerAndIrradianceTrendUrl, model);
  }
  public getShiftsBySiteId(siteId: string): Observable<any> {
    return this.dataService.getData(this.shiftsBySiteIdUrl + '/' + siteId);
  }
  public getSolarEnergyTrendsData(model: any): Observable<any> {
    return this.dataService.saveData(this.solarEnergyTrendsDataUrl, model);
  }
  public getSolarLongTermTrendsBuildingWiseUrl(model: any): Observable<any> {
    return this.dataService.saveData(
      this.solarLongTermTrendsBuildingWiseUrl,
      model
    );
  }
  public getWindSpeed(siteId: string): Observable<any> {
    return this.dataService.getData(this.getWindSpeedUrl + '/' + siteId);
  }
}
